import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { ArrowIcon } from '../../../../../assets/icons/index';
import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import { useLocale } from '../../../../../hooks/index';

export type MobileFolderPanelProps = {
  children: ReactNode;
  className?: string;
  count?: number;
  onBack: () => void;
  title: ReactNode;
};

export const MobileFolderPanel: FC<MobileFolderPanelProps> = ({
  children,
  className,
  count,
  onBack,
  title,
}) => {
  const { messagesLocale } = useLocale();

  return (
    <div
      className={twMerge(
        'flex flex-col gap-3 rounded-lg border border-gray-100 px-3 pb-3 pt-2',
        className,
      )}
    >
      <div className="flex items-center gap-3">
        <button
          aria-label={messagesLocale['BACK']}
          className="flex size-9 shrink-0 items-center justify-center rounded-full border border-[#F2F2F2] bg-white shadow-[0px_0px_12px_rgba(0,0,0,0.08)]"
          onClick={onBack}
          type="button"
        >
          <ArrowIcon className="size-4" height={16} width={16} />
        </button>
        <div className="flex min-w-0 flex-col">
          <p className="truncate text-base font-semibold leading-8 text-gray-700">{title}</p>
          {count !== undefined && (
            <p className="text-label-sm font-medium text-gray-500">
              <AppFormattedMessage id="ITEMS_COUNT" values={{ count }} />
            </p>
          )}
        </div>
      </div>
      {children}
    </div>
  );
};
